export default "__VITE_ASSET__1967b28f__"